import { getCurrentEnvironment } from './getEnvironment'
import { ONBOARDING_COOKIE_NAME } from './onboardingCookie'
import { ONLY_PAGE_PATHS } from './onlyPages'
import {
  PATIENT_PATHS,
  SHARED_PATHS,
  CLIENT_PATHS,
  CLIENT_PUBLIC_LEGAL_PATHS,
  isPathOrChildPath,
} from './paths'
import { STYTCH_SESSION_JWT_COOKIE } from './stytch/constants'
// Centralized configuration for constants.
export const config = {
  isDev: getCurrentEnvironment() === 'development',
  cookies: {
    session: STYTCH_SESSION_JWT_COOKIE,
    onboarding: ONBOARDING_COOKIE_NAME,
  },
  headers: {
    tenantSlug: 'x-tenant-slug',
  },
  paths: {
    client: CLIENT_PATHS,
  },
  onboardingAllowlist: [
    PATIENT_PATHS.welcome,
    SHARED_PATHS.authenticate,
    SHARED_PATHS.login,
    SHARED_PATHS.logout,
    SHARED_PATHS.oauthGooglePopupStart,
    SHARED_PATHS.oauthGooglePopupCallback,
    PATIENT_PATHS.flows.kitRegistration,
    // Only pages (such as the address correction link) are opened from email or SMS and must
    // stay reachable during onboarding.
    ...ONLY_PAGE_PATHS,
    // A closed path is rewritten to the app 404 route. /404 is rewritten there too.
    SHARED_PATHS.notFound,
    SHARED_PATHS.notFoundRender,
  ],
  hipaaConsentAllowlist: [
    PATIENT_PATHS.hipaaConsent,
    SHARED_PATHS.authenticate,
    SHARED_PATHS.login,
    SHARED_PATHS.logout,
    SHARED_PATHS.oauthGooglePopupStart,
    SHARED_PATHS.oauthGooglePopupCallback,
    SHARED_PATHS.admin,
    SHARED_PATHS.healthy,
    // HIPAA consent is collected inline during the consent-agreement step, so there is no need to display a standalone HIPAA consent screen during kit registration.
    PATIENT_PATHS.flows.kitRegistration,
    // Only pages must stay reachable while HIPAA consent is pending.
    ...ONLY_PAGE_PATHS,
    // A closed path is rewritten to the app 404 route. /404 is rewritten there too.
    SHARED_PATHS.notFound,
    SHARED_PATHS.notFoundRender,
  ],
  isPublicClientPath: (path: string): boolean => {
    return (
      path === SHARED_PATHS.root ||
      [
        config.paths.client.login,
        ...CLIENT_PUBLIC_LEGAL_PATHS,
        SHARED_PATHS.login,
        SHARED_PATHS.authenticate,
        SHARED_PATHS.logout,
        SHARED_PATHS.oauthGooglePopupStart,
        SHARED_PATHS.oauthGooglePopupCallback,
        SHARED_PATHS.healthy,
      ].some((p) => path.startsWith(p))
    )
  },
  isPublicPatientPath: (path: string): boolean => {
    return (
      path === SHARED_PATHS.root ||
      [
        SHARED_PATHS.login,
        SHARED_PATHS.authenticate,
        SHARED_PATHS.logout,
        SHARED_PATHS.oauthGooglePopupStart,
        SHARED_PATHS.oauthGooglePopupCallback,
        SHARED_PATHS.admin,
        SHARED_PATHS.healthy,
      ].some((p) => path.startsWith(p)) ||
      isPathOrChildPath(path, SHARED_PATHS.notFound) ||
      isPathOrChildPath(path, SHARED_PATHS.notFoundRender) ||
      ONLY_PAGE_PATHS.some((p) => isPathOrChildPath(path, p)) ||
      /^\/[^/]+\/login$/.test(path)
    )
  },
}
